// @ts-strict-ignore
import { useState } from 'react'

import { fetchPromotions } from '@/entities/sales'

import { usePagination } from '@/shared/providers/PaginationProvider/paginationProvider'
import { TProduct } from '@/shared/types/product-types'
import { MorePaginationButton } from '@/shared/ui/MorePaginationButton/MorePaginationButton'

import { SalesItemTypes } from '../../../../store/types/sales'

import { PromotionsList } from './ui/PromotionsList/PromotionsList'

import styles from './styles.module.scss'

type SalesData = {
	ITEMS: SalesItemTypes[]
	productList?: TProduct[]
	push?: boolean
	TOTAL?: number
	PER_PAGE?: number
	CURRENT_PAGE?: number
	LAST_PAGE?: number
}

export const Sales = ({ ITEMS }: Pick<SalesData, `ITEMS`>): JSX.Element => {
	const { currentPage, lastPage, goToPage } = usePagination()
	const [promotions, setPromotions] = useState<SalesItemTypes[]>(ITEMS)

	const isNotLastPage = lastPage !== currentPage
	const [isPaginationDisabled, setIsPaginationDisabled] = useState<boolean>(false)

	const onPaginationClick = (page: number) => async () => {
		setIsPaginationDisabled(true)

		const promotions = await fetchPromotions(page)

		if (promotions) {
			await goToPage(page, true)
			setPromotions(promotions.ITEMS)
			setIsPaginationDisabled(false)
		}
	}

	return (
		<section className={styles.promotions}>
			<h1 className={styles.promotionsTitle}>Акции</h1>
			<div className={styles.promotionsInner}>
				<PromotionsList items={promotions} />
			</div>
			{isNotLastPage && (
				<MorePaginationButton
					ariaLabel="Показать ещё больше товаров"
					onClick={onPaginationClick(currentPage + 1)}
					disabled={isPaginationDisabled}>
					Показать еще
				</MorePaginationButton>
			)}
		</section>
	)
}
